import { useEffect, useMemo, useState } from 'react';
import { ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { RoleType } from '../../../../../../store/api/role-api';
import { useAdminsStore } from '../../../../../../store/use-admins-store';
import { useRoleStore } from '../../../../../../store/use-role-store';
import { IdValue } from '../../../../../../types/props';

const scopeOptions: IdValue[] = [
  {
    id: 'company',
    value: 'Компания',
  },
  {
    id: 'branch',
    value: 'Филиал',
  },
  {
    id: 'role',
    value: 'Роль',
  },
];

export const useRolesDictionaryCreateModal = (props: ModalProps) => {
  const { t, getLocale } = useLang();
  const { fetchRoleById, roles, postRole, putRole, isLoading } = useRoleStore();
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const { roleId, isSystem } = params;
  const { list: admins } = useAdminsStore();
  const [role, setRole] = useState<Partial<RoleType>>();

  useEffect(() => {
    if (roleId) {
      fetchRoleById(roleId)?.then(setRole);
    } else {
      setRole(undefined);
    }
  }, [roleId]);

  const adminIdValues = useMemo(() => {
    const mapped = admins?.map((item) => ({
      id: String(item.id),
      value: `${getLocale(item.name)} ${getLocale(item.surname)}`,
    }));
    return mapped;
  }, [admins]);

  const rolesIdValues = useMemo(
    () => roles?.map((item) => ({ id: item.id, value: item.name })) || [],
    [roles],
  );

  const scopeIdValues = useMemo(
    () => scopeOptions?.map((item) => ({ id: item.id, value: t(item.value) })) || [],
    [scopeOptions],
  );

  const handleSubmit = async () => {
    try {
      if (role) {
        role.scope = 'company';
      }
      if (roleId) {
        await putRole(role as RoleType);
      } else {
        await postRole(role as RoleType);
      }
      props.onClose?.();
    } catch (error) {
      console.error('Error saving role:', error);
    }
  };

  return {
    role,
    setRole,
    adminIdValues,
    admins,
    rolesIdValues,
    scopeIdValues,
    handleSubmit,
    t,
    isSystem,
    getLocale,
    isLoading,
  };
};
